<template>
  <v-app class="app-shell">
    <v-navigation-drawer
      v-model="drawer"
      app
      dark
      width="288"
      class="nav-drawer indigo darken-1"
      :mobile-breakpoint="960"
    >
      <div class="nav-drawer__header">
        <div class="nav-user">
          <v-avatar size="40" color="primary lighten-1" class="nav-user__avatar">
            <v-icon>mdi-account</v-icon>
          </v-avatar>
          <div class="nav-user__meta">
            <div class="nav-user__name text-truncate">
              <span v-if="role!='Petugas'">{{ user.email }}</span>
              <span v-else>{{ station }}</span>
            </div>
            <div class="nav-user__role">{{ role }}</div>
          </div>
        </div>
      </div>

      <v-divider class="mx-3"></v-divider>

      <div class="nav-drawer__scroll">
        <!-- Staff / admin navigation -->
        <v-list v-if="role!='Petugas'" nav dense class="nav-list py-2">
          <v-list-group
            v-for="group in navGroups"
            :key="group.key"
            :value="groupOpen[group.key]"
            :prepend-icon="group.icon"
            no-action
            color="white"
            class="nav-group"
            @input="$set(groupOpen, group.key, $event)"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="nav-group__title">{{ group.title }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="item in group.items"
              :key="item.path + item.page"
              :to="item.path"
              :exact="item.path === '/'"
              link
              class="nav-item"
              active-class="nav-item--active"
            >
              <v-list-item-icon class="mr-3">
                <v-icon small>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.page }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-subheader class="nav-subheader mt-2">Referensi</v-subheader>
          <v-list-item
            href="https://firebasestorage.googleapis.com/v0/b/rainmonitor-b0968.appspot.com/o/ARMOS.pdf?alt=media"
            target="_blank"
            rel="noopener"
            class="nav-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-book-open-page-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Manual Book</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://drive.google.com/file/d/14CLL0r9tHGnTj7hRHTJ61BHlzDywfMlr/view?usp=drivesdk"
            target="_blank"
            rel="noopener"
            class="nav-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-play-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Manual Video</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="user.email!=='beta@test.com'"
            to="/MCB"
            link
            class="nav-item"
            active-class="nav-item--active"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-school</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>SIPENJAJA Buku Pintar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- Petugas navigation -->
        <v-list v-else nav dense class="nav-list py-2">
          <v-list-item
            v-for="item in petugasPages"
            :key="item.path"
            :to="item.path"
            link
            class="nav-item"
            active-class="nav-item--active"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.page }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader class="nav-subheader mt-2">Referensi</v-subheader>
          <v-list-item
            href="https://firebasestorage.googleapis.com/v0/b/rainmonitor-b0968.appspot.com/o/ARMOS.pdf?alt=media"
            target="_blank"
            rel="noopener"
            class="nav-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-book-open-page-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Manual Book</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://drive.google.com/file/d/14CLL0r9tHGnTj7hRHTJ61BHlzDywfMlr/view?usp=drivesdk"
            target="_blank"
            rel="noopener"
            class="nav-item"
          >
            <v-list-item-icon class="mr-3">
              <v-icon small>mdi-play-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Manual Video</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <template v-slot:append>
        <div class="nav-drawer__footer">
          <v-btn
            block
            depressed
            color="error"
            class="logout-btn"
            @click="SignOut"
          >
            <v-icon left small>mdi-logout</v-icon>
            Logout
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      flat
      elevate-on-scroll
      color="primary"
      dark
      class="app-topbar"
      height="64"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="d-flex align-center app-brand">
        <v-img
          alt="Dinas Logo"
          class="shrink mr-2"
          contain
          src="@/assets/provinsi.png"
          transition="scale-transition"
          width="36"
          max-height="36"
        />
        <v-img
          alt="ARMOS Logo"
          class="shrink app-brand__logo"
          contain
          src="@/assets/icon.png"
          transition="scale-transition"
          max-height="36"
        />
      </div>

      <v-divider vertical class="mx-3 d-none d-md-flex app-topbar__divider"></v-divider>

      <div class="app-page-title d-none d-md-block text-truncate">
        {{ pageTitle }}
      </div>

      <v-spacer></v-spacer>

      <v-chip
        small
        outlined
        class="version-chip mr-1"
      >
        {{ appVersion }}
      </v-chip>
    </v-app-bar>

    <v-main class="app-main">
      <div class="app-main__inner">
        <router-view/>
      </div>
      <v-snackbar
        v-model="snackbar2"
        :vertical="true"
        centered
        color="red darken-2"
        :timeout="-1"
      >
        {{ notif }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="warning"
            text
            v-bind="attrs"
            @click="snackbar2 = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar bottom right :value="updateExists" :timeout="-1" color="secondary darken-2">
        An update is available click update to refresh
        <v-btn text @click="refreshApp">
          Update
        </v-btn>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import moment from 'moment'
import firebase from "firebase/app"
import 'firebase/auth'
import { db }from "../firebase/db.js"

const DEVICE_ADMIN_EMAILS = [
  'ammarnov@gmail.com',
  'admin@admin.com',
  'zulhazmi35@gmail.com',
  'fkrfauzi@gmail.com',
  'taufikirwanpratama100@gmail.com',
]

const PAGE_META = {
  Map: { path: '/', page: 'Peta', group: 'maps', icon: 'mdi-map' },
  MapGPS: { path: '/MapGPS', page: 'Peta GPS', group: 'maps', icon: 'mdi-crosshairs-gps' },
  Condition: { path: '/Condition', page: 'Tabel Kondisi', group: 'monitoring', icon: 'mdi-table' },
  History: { path: '/History', page: 'Tabel Historis', group: 'monitoring', icon: 'mdi-history' },
  Notification: { path: '/Notification', page: 'Notifikasi PCH', group: 'monitoring', icon: 'mdi-bell-outline' },
  NotificationTMA: { path: '/NotificationTMA', page: 'Notifikasi TMA', group: 'monitoring', icon: 'mdi-bell-ring-outline' },
  Recap: { path: '/Recap', page: 'Rekapitulasi', group: 'analytics', icon: 'mdi-file-chart-outline' },
  Chart: { path: '/Chart', page: 'Grafik PCH', group: 'analytics', icon: 'mdi-chart-bar' },
  ChartTMA: { path: '/ChartTMA', page: 'Grafik TMA', group: 'analytics', icon: 'mdi-chart-line' },
  DownloadFile: { path: '/DownloadFile', page: 'Log File', group: 'logs', icon: 'mdi-file-download-outline' },
  DownloadFileMonthly: { path: '/DownloadFileMonthly', page: 'Log File Bulanan', group: 'logs', icon: 'mdi-calendar-month-outline' },
  ICCIDList: { path: '/ICCIDList', page: 'ICCID List', group: 'logs', icon: 'mdi-barcode' },
  AddDevice: { path: '/AddDevice', page: 'Add Device', group: 'admin', icon: 'mdi-plus-circle-outline' },
  Administrator: { path: '/Administrator', page: 'Administrator', group: 'admin', icon: 'mdi-account-cog-outline' },
  AdminTMA: { path: '/AdminTMA', page: 'Administrator TMA', group: 'admin', icon: 'mdi-water' },
}

const GROUP_META = [
  { key: 'maps', title: 'Peta', icon: 'mdi-map-outline' },
  { key: 'monitoring', title: 'Monitoring', icon: 'mdi-monitor-dashboard' },
  { key: 'analytics', title: 'Analitik', icon: 'mdi-chart-areaspline' },
  { key: 'logs', title: 'Log & Data', icon: 'mdi-database-outline' },
  { key: 'admin', title: 'Administrasi', icon: 'mdi-shield-account-outline' },
]

export default {
  name: 'Logged',

  data: () => ({
    user: {
      initials: '',
      fullName: '',
      email: '',
      role:'',
    },
    time: {
      day:moment(new Date()).format("dddd"),
      time:moment(new Date()).format("HH:mm"),
      date:moment(new Date()).format("DD MMM YYYY")
    },
    newPassword:'',
    dialog: false,
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >=8) || 'Password must be at least 8 characters'
    ],
    snackbar:false,
    timeout: 2000,
    drawer: null,
    snackbar2:false,
    notif:'',
    offset:0,
    role:'',
    station:'',
    MapPetugas:'',
    NotifikasiPetugas:'',
    KondisiPetugas:'',
    RekapPetugas:'',
    ChartPetugas:'',
    userRef:null,
    pages:[],
    groupOpen: {},
    registration: null,
    updateExists: false,
    refreshing:false
  }),
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION || 'v.2507151334'
    },
    isDeviceAdmin() {
      return DEVICE_ADMIN_EMAILS.includes(this.user.email)
    },
    navGroups() {
      const buckets = {}
      GROUP_META.forEach((group) => {
        buckets[group.key] = { ...group, items: [] }
      })

      this.pages.forEach((page) => {
        if (buckets[page.group]) {
          buckets[page.group].items.push(page)
        }
      })

      if (this.isDeviceAdmin) {
        buckets.admin.items.push(
          { path: '/deviceCalib', page: 'Configuration', group: 'admin', icon: 'mdi-tune' },
          { path: '/RegisterDevice', page: 'Register Device', group: 'admin', icon: 'mdi-cellphone-link' },
        )
      }

      return GROUP_META
        .map((group) => buckets[group.key])
        .filter((group) => group.items.length > 0)
    },
    petugasPages() {
      const pages = [
        { path: this.MapPetugas, page: 'Peta', icon: 'mdi-map' },
      ]
      if (this.$route.params.jenis != 'TMA') {
        pages.push({ path: this.KondisiPetugas, page: 'Kondisi', icon: 'mdi-table' })
      }
      pages.push({ path: this.NotifikasiPetugas, page: 'Notifikasi', icon: 'mdi-bell-outline' })
      if (this.$route.params.jenis != 'TMA') {
        pages.push({ path: this.RekapPetugas, page: 'Rekapitulasi', icon: 'mdi-file-chart-outline' })
      }
      pages.push({ path: this.ChartPetugas, page: 'Grafik Rekapitulasi', icon: 'mdi-chart-bar' })
      return pages.filter((p) => !!p.path)
    },
    pageTitle() {
      if (this.role === 'Petugas') {
        const match = this.petugasPages.find((p) => this.$route.fullPath === p.path || this.$route.path === p.path)
        return (match && match.page) || this.$route.name || 'ARMOS'
      }
      const all = this.navGroups.reduce((acc, g) => acc.concat(g.items), [])
      const match = all.find((p) => this.$route.path === p.path)
      return (match && match.page) || this.$route.name || 'ARMOS'
    },
  },
  created() {
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }
  },
  mounted() {
    this.role=localStorage.getItem("role");
    this.station=localStorage.getItem("station");
    if (this.role=='Petugas') {
      this.MapPetugas=`/MapPetugas-id=${localStorage.getItem("device")}&device=${localStorage.getItem("jenis")}`
      this.NotifikasiPetugas=`/NotificationPetugas-id=${localStorage.getItem("device")}&device=${localStorage.getItem("jenis")}`
      this.KondisiPetugas=`/DataPetugas-id=${localStorage.getItem("device")}&device=${localStorage.getItem("jenis")}`
      this.RekapPetugas=`/RecapPetugas-id=${localStorage.getItem("device")}&device=${localStorage.getItem("jenis")}`
      this.ChartPetugas=`/ChartPetugas-id=${localStorage.getItem("device")}&device=${localStorage.getItem("jenis")}`
    }
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    this.initPushNotifications()
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        var uid = user.uid;
        this.registerMessagingToken(uid)
        if (localStorage.getItem("role")!='Petugas') {
          this.user.email=user.email;
          this.userRef=db.collection('user').doc(uid).onSnapshot((doc) => {
            localStorage.setItem("role", doc.data().role);
            this.role=doc.data().role
            localStorage.setItem("location", doc.data().location);
            db.collection('roleSetting').doc(this.role).get().then((doc) => {
              this.pages=[]
              doc.data().page.forEach((path) => {
                const meta = PAGE_META[path]
                if (meta) {
                  this.pages.push({ ...meta })
                }
              })
            })
            if (doc.data().confirmed !==false) {
                console.log(doc.data().role)
            } else {
                this.$router.push('confirm')
            }
          })
        }

      } else {
        let uid=localStorage.getItem('uid')
        let messaging = localStorage.getItem('messaging')
        if ((messaging!=null)&&(uid!=null)) {
          db.collection("user").doc(uid).collection('notifToken').doc(messaging).delete().then(() => {
            console.log("Document successfully deleted!");
            localStorage.removeItem('uid')
            localStorage.removeItem('station')
            localStorage.removeItem('role')
            localStorage.removeItem('location')
            localStorage.removeItem('device')
            localStorage.removeItem('jenis')
            localStorage.removeItem('messaging')
            this.$router.push('login')
          }).catch((error) => {
              console.error("Error removing document: ", error);
          });
        } else {
          localStorage.removeItem('uid')
          localStorage.removeItem('station')
          localStorage.removeItem('role')
          localStorage.removeItem('location')
          localStorage.removeItem('device')
          localStorage.removeItem('jenis')
          localStorage.removeItem('messaging')
          this.$router.push('login')
        }

      }
    });
  },
  watch : {
    navGroups: {
      immediate: true,
      handler(groups) {
        groups.forEach((group) => {
          if (this.groupOpen[group.key] === undefined) {
            this.$set(this.groupOpen, group.key, true)
          }
        })
      },
    },
    '$route'() {
      this.navGroups.forEach((group) => {
        if (this.isGroupOpen(group)) {
          this.$set(this.groupOpen, group.key, true)
        }
      })
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false
      }
    },
  },
  methods: {
    isGroupOpen(group) {
      return group.items.some((item) => this.$route.path === item.path)
    },
    updateAvailable(event) {
      console.log('update available!')
      this.registration = event.detail
      this.updateExists = true
    },
    refreshApp() {
      console.log('Refreshing App!')
      this.updateExists = false
      if (!this.registration || !this.registration.waiting) return
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
    async initPushNotifications() {
      if (!this.$messaging || typeof Notification === 'undefined') return
      try {
        const permission = await Notification.requestPermission()
        if (permission !== 'granted') return
        this.$messaging.onMessage((payload) => {
          this.snackbar2=true
          let notiftext= payload.data.body
          let textArray = notiftext.split('&')
          this.notif=''
          textArray[1]= this.updateTime(textArray[1])
          for (let i=0;i<textArray.length;i++) {
            if (textArray[i]!= undefined) {
              this.notif= this.notif.concat(textArray[i])
            }
          }
        })
      } catch (err) {
        console.warn('Push notifications unavailable', err)
      }
    },
    registerMessagingToken(uid) {
      if (!this.$messaging || !uid) return
      const date=new Date();
      this.$messaging.getToken({ vapidKey: 'BOay1Is0uJGXdH8ZYWfGDUhHCpLsTTu_MqBhadVNe1_1KximU7vO8d-FusSbaIkmKiFlceT09EbMjQahSLe2Ovg' }).then((currentToken)=> {
        if (currentToken) {
          localStorage.setItem("messaging",currentToken)
          db.collection('user').doc(uid).collection('notifToken').doc(currentToken).set({
            token:currentToken,
            time: Math.floor(date.getTime()/1000)
          })
        } else {
          console.log('No registration token available. Request permission to generate one.');
        }
      }).catch((err)=> {
        console.log(err)
      })
    },
    updateTime (time) {
      return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
    },
    async SignOut() {
      let uid=localStorage.getItem('uid')
      let messaging = localStorage.getItem('messaging')
      if ((messaging!=null)&&(uid!=null)) {
        await db.collection("user").doc(uid).collection('notifToken').doc(messaging).delete().then(() => {
            console.log("Document successfully deleted!");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
      }
      firebase.auth().signOut().then(() => {
        localStorage.removeItem('uid')
        localStorage.removeItem('station')
        localStorage.removeItem('role')
        localStorage.removeItem('location')
        localStorage.removeItem('device')
        localStorage.removeItem('messaging')
        localStorage.removeItem('jenis')
        this.$router.push('login')
      }).catch((error) => {
        console.log(error)
      });
    },
    ChangePassword(newPassword) {
      const user = firebase.auth().currentUser;
      user.updatePassword(newPassword).then(() => {
        this.dialog=false
        this.snackbar=true
      }).catch((error) => {
        console.log(error)
      });
    },
  }
}
</script>

<style scoped>
.app-shell {
  background: #eef2f7;
}

.nav-drawer {
  border-right: none !important;
}

.nav-drawer__header {
  padding: 16px 16px 12px;
}

.nav-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
}

.nav-user__avatar {
  flex-shrink: 0;
}

.nav-user__meta {
  min-width: 0;
  flex: 1;
}

.nav-user__name {
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}

.nav-user__role {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
}

.nav-drawer__scroll {
  overflow-y: auto;
  max-height: calc(100vh - 180px);
  padding: 4px 8px 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.35) rgba(0, 0, 0, 0.2);
}

.nav-drawer__scroll::-webkit-scrollbar {
  width: 8px;
}

.nav-drawer__scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.nav-drawer__scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 8px;
}

.nav-drawer__scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

.nav-list >>> .v-list-group__header {
  border-radius: 10px !important;
  margin: 2px 0;
  min-height: 40px !important;
}

.nav-group__title {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
}

.nav-subheader {
  font-size: 11px !important;
  font-weight: 600 !important;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55) !important;
  height: auto !important;
  padding: 12px 12px 6px !important;
}

.nav-item {
  border-radius: 10px !important;
  margin: 2px 0 2px 4px;
  min-height: 38px !important;
}

.nav-item >>> .v-list-item__title {
  font-size: 13px !important;
  color: rgba(255, 255, 255, 0.88);
}

.nav-item >>> .v-icon {
  color: rgba(255, 255, 255, 0.75);
}

.nav-item--active {
  background: rgba(255, 255, 255, 0.16) !important;
}

.nav-item--active >>> .v-list-item__title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

.nav-item--active >>> .v-icon {
  color: #ffffff !important;
}

.nav-drawer__footer {
  padding: 12px 16px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  background: transparent;
}

.logout-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
}

.app-topbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.app-topbar__divider {
  height: 28px;
  align-self: center;
  border-color: rgba(255, 255, 255, 0.35) !important;
}

.app-brand {
  gap: 4px;
  min-width: 0;
}

.app-brand__logo {
  width: 150px;
  max-width: min(150px, 42vw);
}

.app-page-title {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  max-width: 280px;
}

.version-chip {
  font-weight: 500 !important;
  opacity: 0.9;
  border-color: rgba(255, 255, 255, 0.55) !important;
  color: #ffffff !important;
}

.app-main {
  background: #eef2f7;
}

.app-main__inner {
  min-height: 100%;
}

@media (max-width: 599.98px) {
  .nav-drawer__scroll {
    max-height: calc(100vh - 160px);
  }

  .app-page-title {
    max-width: 140px;
    font-size: 14px;
  }

  .version-chip {
    font-size: 10px !important;
    height: 22px !important;
  }
}
</style>
